import { useEffect } from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Typography } from 'components/common/typography'
import { NeutralButtonOutline, SecondaryButton } from 'components/common/button'
import { useLesson } from 'querys/lesson'
import { useCourse } from 'querys/course'
import { useCreateCourseEnrolment } from 'mutations/course'
import { sendToDataLayer } from 'utils/push-to-datalayer'
import { fbqEvent } from 'utils/fbq'

const WhiteButtonOutline = styled(NeutralButtonOutline)`
  border: 1px solid white!important;
  color: var(--white)!important;
`

const UnlockClassStyled = styled.section`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 16px;
  z-index: 10;
  img {
    display: block;
    margin: 0 auto;
    margin-bottom: 8px;
  }
  h1 {
    max-width: 240px;
    margin: 0 auto;
  }
  .unlock-bg {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: var(--neutral110);
    opacity: 0.9;
    backdrop-filter: blur(2px);
  }
  .unlock-container {
    position: relative;
    z-index: 2;
  }
  .btn-container {
    margin-top: 16px;
    a {
      margin-bottom: 16px;
    }
  }
  @media (min-width: 768px) {
    h1 {
      max-width: initial;
    }
    .btn-container {
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        margin-bottom: 0px;
        margin-right: 16px;
      }
    }
  }
`

export default function UnlockClass() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const router = useRouter()
  const { data: course } = useCourse()
  const queryLesson = useLesson()
  const { data: { has_access: freeClass, course: { slug } }, token } = useLesson()
  const handleSuccess = () => {
    queryLesson.refetch()
  }
  const enrolmentMutation = useCreateCourseEnrolment(slug, handleSuccess)
  const { mutate } = enrolmentMutation

  const createEnrolment = (e) => {
    fbqEvent({ event: 'create_free_enrollment' })
    sendToDataLayer({
      event: 'create_free_enrollment',
      cta_id: e.target.id,
    })
    mutate()
  }

  if (course?.has_access) return null
  if (freeClass && token) return null

  const isFree = course?.is_free
  const freeCourseWithoutLogin = isFree && !token
  const freeClassWithoutLogin = freeClass && !token
  const enrollmentNeeded = isFree && token && !freeClass
  const privateClass = !isFree && !freeClass

  const freeCourseId = { login: 'login_from_ls_free_course', register: 'register_from_ls_free_course' }
  const usualID = { login: 'login_from_lesson', register: 'register_from_lesson' }
  const ids = isFree ? freeCourseId : usualID

  return (
    <UnlockClassStyled role="region" aria-labelledby="unlock-title">
      <div className="unlock-bg" />
      <div className="unlock-container">
        <img width="35" height="26.67" src="/images/courses/landing-padlock.svg" alt="Icono de un elemento bloqueado, es un candado" />
        <Typography id="unlock-title" color="var(--white)" as="h1" align="center" small="headline6" large="headline5">
          {freeCourseWithoutLogin ? 'Inicia sesión o regístrate gratis para ver este curso' : null}
          {freeClassWithoutLogin && !freeClassWithoutLogin ? 'Inicia sesión para ver esta clase gratis' : null}
          {enrollmentNeeded ? 'Este curso es gratuito, ¿quieres empezar el curso?' : null}
          {privateClass ? 'Esta es una clase Premium' : null}
        </Typography>
        <div className="btn-container">
          {!token && (
            <>
              <Link href={`/login?next=${router.asPath}`} passHref>
                <SecondaryButton id={ids.login} height="47" fullWidth fitContent>
                  Iniciar sesión
                </SecondaryButton>
              </Link>
              <Link href={`/registro?next=${router.asPath}`} passHref>
                <WhiteButtonOutline id={ids.register} redesign height="47" fullWidth fitContent>
                  Regístrate
                </WhiteButtonOutline>
              </Link>
            </>
          )}
          {isFree ? (
            <>
              {token && (
                <SecondaryButton
                  id="create_enrollment_from_lesson"
                  fullWidth
                  fitContent
                  onClick={(e) => createEnrolment(e)}
                >
                  Empezar curso
                </SecondaryButton>
              )}
            </>
          ) : (
            <Link href={`/cursos/${slug}`} passHref>
              <SecondaryButton height="48" fullWidth fitContent>
                Ver temario
              </SecondaryButton>
            </Link>
          )}
        </div>
      </div>
    </UnlockClassStyled>
  )
}
